import { LoadingOutlined } from "@ant-design/icons";

const ButtonSpinner = () => <LoadingOutlined style={{ color: "#fff" }} />;

export default ButtonSpinner;
